import React, { useState } from 'react';
import { ExternalLink, Search, Plus } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { safeUrl } from './SourceMeta';

export const HoldingsPanel = ({ holdings, onWatchManager }) => {
  const [manager, setManager] = useState('');
  const add = () => {
    if (manager.trim()) onWatchManager(manager.trim());
    setManager('');
  };
  return (
    <div className="space-y-3" data-testid="research-holdings-panel">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
          <Input value={manager} onChange={(e) => setManager(e.target.value.slice(0, 80))} placeholder="Investor / manager name"
            className="input-dark pl-9" data-testid="research-manager-input" />
        </div>
        <Button variant="outline" onClick={add} className="bg-white/5 border-white/10 text-white" data-testid="research-manager-watch-btn">
          <Plus className="w-4 h-4 mr-1" /> Watch
        </Button>
      </div>
      <h4 className="text-sm font-semibold text-white">{holdings?.label || 'Reported holdings changes'}</h4>
      <table className="w-full text-xs text-left text-gray-400" data-testid="research-holdings-table">
        <thead><tr className="border-b border-white/10">
          <th className="py-2">Manager</th><th>Quarter end</th><th>Filing date</th><th>Reported change</th>
        </tr></thead>
        <tbody><tr><td colSpan={4} className="py-4 text-center" data-testid="research-holdings-unavailable">
          {holdings?.reason || 'Holdings data unavailable.'}
        </td></tr></tbody>
      </table>
      <p className="text-xs text-gray-500">Form 13F filings are delayed quarter-end snapshots with incomplete coverage, not live trades.</p>
      {(holdings?.externalLinks || []).map((l) => safeUrl(l.url) && (
        <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer" data-testid="research-stockcircle-link"
          className="inline-flex items-center gap-1 text-xs text-[#00E676] hover:underline">
          {l.label} <ExternalLink className="w-3 h-3" />
        </a>
      ))}
    </div>
  );
};
